import { AvailableTabs } from 'constants/SidebarTabs';
import { Dropoff, NormalizedLoad, Pickup } from 'types/Load';
import { Maybe } from 'types/UtilityTypes';

import { getCurrentUrl } from './current-url';
import { TMSHost } from './interface';

function extractRevenovaLoadIdFromUrl(urlString: string): string {
  let url: URL;

  try {
    url = new URL(urlString);
  } catch {
    return '';
  }

  const segments = url.pathname.split('/').filter(Boolean);

  const loadTypeIndex = segments.findIndex(
    (segment) => segment === 'rtms__Load__c'
  );

  if (loadTypeIndex === -1) {
    return '';
  }

  const prefixSegment = segments[loadTypeIndex - 1];

  if (prefixSegment !== 'r') {
    return '';
  }

  const recordId = segments[loadTypeIndex + 1];

  if (!recordId) {
    return '';
  }

  return recordId;
}

export class Revenova implements TMSHost {
  private getCurrentUrl: () => string;

  constructor(getCurrentUrlFn?: () => string) {
    this.getCurrentUrl = getCurrentUrlFn || getCurrentUrl;
  }

  getFieldMoniker(key: keyof NormalizedLoad): string {
    return key === 'freightTrackingID' ? 'Load ID' : '';
  }

  parseFreightTrackingID(): string {
    const url = this.getCurrentUrl();
    return extractRevenovaLoadIdFromUrl(url);
  }

  parseExternalTMSID(): string {
    return this.parseFreightTrackingID();
  }

  parsePickup(): Maybe<Pickup> {
    return null;
  }

  parseDropoff(): Maybe<Dropoff> {
    // Revenova-specific logic for parsing dropoff information
    // This would depend on how Revenova displays dropoff data on their pages
    // For now, return null as we don't have the specific implementation
    return null;
  }

  determineDefaultLoadTab(): AvailableTabs {
    // Determine which tab should be shown by default for Revenova loads
    // This could be based on user preferences or Revenova-specific requirements
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    // Determine if Drumkit should automatically open on Revenova pages
    // This could be based on specific conditions or user settings
    const url = this.getCurrentUrl();

    if (extractRevenovaLoadIdFromUrl(url) !== '') {
      return true;
    }

    let parsedUrl: URL;

    try {
      parsedUrl = new URL(url);
    } catch {
      return false;
    }

    if (parsedUrl.hostname.includes('lightning.force.com')) {
      return true;
    }

    return false;
  }
}
